import Vue from 'vue'
import VueRouter from 'vue-router'
import {detectDeviceType} from '@/utils/utils'
import store from '@/store/store'
import mobile from './mobile'
import desktop from './desktop'
import publicRouters from './publicRouter'

Vue.use(VueRouter)

const desktopRoutes = [
    ...publicRouters,
    ...desktop
]
const mobileRoutes = [
    ...publicRouters,
    ...mobile
]
const deviceType = detectDeviceType();
// console.log(deviceType);

const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err)
}
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: deviceType ? mobileRoutes : desktopRoutes
    // routes: desktopRoutes
})
router.beforeEach((to,from,next)=>{
    if(to.meta.title){
      document.title = to.meta.title;
    }
    if (to.meta.requiresAuth && !store.state.isLogin) {
      next({ path: '/login' })
    }else{
      next();
    }
  })
export default router;

